import { Language } from '../../enums/language/language';

export class EventRecording {
  public description: string;
  public timecode: number;
  public videoUrl?: string;
  public language?: Language;
}
